import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useOrderAvailableDates,
    useOrderExpectedAt,
    useOrderIsSyncingTimeSlots,
    setOrderExpectedAt,
    getOrderAvailableTimes,
} from '@/hooks/api/order';

const OrderDatePicker = () => {
    const [t] = useTranslation('order.datetime');
    const available_dates = useOrderAvailableDates();
    const expected_at = useOrderExpectedAt();
    const is_syncing = useOrderIsSyncingTimeSlots();

    const onChange = useCallback(
        event => {
            const { value } = event.target;
            const available_times = getOrderAvailableTimes(value);

            if (!available_times.length) {
                return;
            }

            // Try to find the same time slot for the new date.
            // Fallback to first time slots if it isn't available.
            // @todo: possible improvements would be to find the closest
            // time slot for the new date.
            const new_date_same_time = available_times.find(
                time =>
                    time.display_value === expected_at?.display_value &&
                    time.date_value === value
            );
            setOrderExpectedAt(new_date_same_time || available_times[0]);
        },
        [expected_at]
    );

    return (
        <div
            className="m2g-order-date m2g-input-container"
            data-icon-after={
                !is_syncing && available_dates.length > 1 && 'select'
            }
            data-view="order-dates"
        >
            {available_dates?.length ? (
                <select
                    data-order-dates
                    className="m2g-order-date-select m2g-select"
                    value={expected_at?.date_value}
                    onChange={onChange}
                >
                    {available_dates.map(date => {
                        return (
                            <option
                                key={date.date_value}
                                value={date.date_value}
                                data-display-value={date.display_value}
                                disabled={date.is_closed}
                            >
                                {date.display_value}
                                {date.is_closed && ` ${t('time_closed')}`}
                                {date.surcharge &&
                                    ` ${t('time_surcharge', {
                                        surcharge: date.surcharge,
                                    })}`}
                            </option>
                        );
                    })}
                </select>
            ) : (
                <select
                    data-order-dates
                    className="m2g-order-date-select m2g-select m2g-text--offset"
                >
                    <option value="">{is_syncing ? '' : t('closed')}</option>
                </select>
            )}
        </div>
    );
};

export default OrderDatePicker;
